import { HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetPersonByCPFUseCaseInterface } from 'domain/usecases';

export class RemoteGetPersonByCPF implements GetPersonByCPFUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetPersonByCPFUseCaseInterface.Params,
  ): Promise<GetPersonByCPFUseCaseInterface.Result> {
    const { cpf, ...restParams } = params;
    const requestUrl = `${this.url}/find-by-cpf/${cpf}`;

    const httpResponse = await this.httpClient.request({
      url: generateUrl(requestUrl, restParams),
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
